import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CryptoJS from 'crypto-js';

import { Loader } from '../../atoms';
import { AuthService } from '../../../services';
import { UserContext } from '../../../context';
import { default as t } from '../../../utils/i18n';
import { validateEmail } from '../../../utils/input.validator';

import './signin-account.scss';
const SignInAccount = props => {
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();

  let parsedUserData = null;
  try {
    let data = localStorage.getItem('user');
    if (data) {
      parsedUserData = JSON.parse(data);
    }
  } catch (error) {
    console.error('Error parsing data from localStorage:', error);
  }
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [emailValidationError, setEmailValidationError] = useState(null);
  const [passwordValidationError, setPasswordValidationError] = useState(null);
  const [authenticated, setAuthenticated] = useState(parsedUserData?.authenticated);

  const loadingDefaultState = {
    buttonText: t('signin.button.label'),
    buttonClass: '',
    loadingIcon: false,
  };
  const [isLoading, setIsLoading] = useState(loadingDefaultState);

   const getEncryptedParams = data => {
    const key = process.env.REACT_APP_AUTH_KEY;
    if (key && CryptoJS?.AES) {
      return CryptoJS.AES.encrypt(data, key).toString();
    } else {
      return '';
    }
  };  
  
  useEffect(() => {
    // if(window.location.hostname !== 'localhost'){
    if (!authenticated) {
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
      setUser(null);
      setTimeout(() => {
        window.location.replace(`${process.env.REACT_APP_UPA_BASE_URL}/signout`);
      }, 100);
    } else {
      history.push('/interstitial');
    }
    // }
  }, []);

  useEffect(() => {
    if (email && password && !validateEmail(email)) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [email, password]);

  const handleChange = e => {
    e.preventDefault();
    setEmailValidationError(null);
    setPasswordValidationError(null);
    const { name, value } = e.target;
    if (name === 'email') setEmail(value.trim());
    else if (name === 'password') setPassword(value.trim());
  };


  const assignRole = roles => {
    if (roles.includes('SUPERADMIN')) {
      return 'SUPERADMIN';
    } else if (roles.includes('ADMIN')) {
      return 'ADMIN';
    } else {
      return '';
    }
  };

  const submitHandler = async e => {
    e.preventDefault();
    let errorMessage = validateEmail(email);
    if (errorMessage) {
      return setEmailValidationError(errorMessage);
    }
    setIsLoading({
      buttonClass: 'button-checking',
      buttonText: `${t('user.buttonText.checking')}`,
      loadingIcon: true,
    });
    try {
      const signInResponse = await AuthService.signIn(email.toLowerCase(), password);
      let stateObject = {
        ...user,
        username: email,
        tokens: signInResponse?.data?.data?.tokens,
        name: signInResponse?.data?.data?.name,
        password: getEncryptedParams(password),
        authenticated: true,
        role: assignRole(signInResponse?.data?.data?.roles),
      };
      localStorage.setItem('user', JSON.stringify(stateObject));
      setUser(stateObject);
      setIsLoading(loadingDefaultState);
      history.push('/interstitial');
    } catch (error) {
      setIsLoading(loadingDefaultState);
      const dataCode = error?.data?.data?.code;
      if (dataCode === 'CL_USR_012') {
        setUser(prevUserState => ({
          ...prevUserState,
          username: email,
        }));
        history.push({
          pathname: '/signUp',
          state: {
            verifyOTP: true,
          },
        });
      } else if (dataCode) {
        if (dataCode === 'CL_USR_007') {
          setPasswordValidationError(t(`error.${dataCode}`));
        } else {
          setEmailValidationError(t(`error.${dataCode}`));
        }
      }
    }
  };

  const handleLionLogin = async () => {
    try {
      // await msalInstance.initialize();
      // msalInstance.loginRedirect({
      //   scopes: ['user.read', 'Offline_access'],
      //   response_type: 'code',
      // });
    } catch (error) {}
  };
  return <Loader />

  // return (
  //   <div className="signin__card-container">
  //     <h1 className="signin__card-heading">{t('signin.heading')}</h1>
  //     <p className="signin__card-subheading">{t('signin.subheading')}</p>
  //     <div className="sso-button-container">
  //       <Button
  //         type="submit"
  //         name="submit"
  //         label={'Login via Publicis Groupe SSO'}
  //         handleClick={handleLionLogin}
  //       />
  //     </div>
  //     <div className="divider"></div>
  //     <div className="signin__form-group">
  //       <form onSubmit={submitHandler}>
  //         <div className="input-container">
  //           <Input
  //             labelValue={t('user.input.label.emailAddress')}
  //             emailToolTip={t('user.input.tooltip.emailAddress')}
  //             name="email"
  //             fieldType="email"
  //             placeholder={t('user.input.placeholder.emailAddress')}
  //             value={email}
  //             handleChange={handleChange}
  //             errorMessage={emailValidationError}
  //           />
  //           <Input
  //             labelValue={t('user.input.label.password')}
  //             name="password"
  //             fieldType="password"
  //             value={password}
  //             placeholder={t('user.input.placeholder.enterPassword')}
  //             handleChange={handleChange}
  //             errorMessage={passwordValidationError}
  //             actionLinkValue={t('user.link.forgotPassword')}
  //             actionLinkRedirect="/forgot"
  //           />
  //         </div>
  //         <div className="button-container">
  //           <Button
  //             type="submit"
  //             name="submit"
  //             label={isLoading.buttonText}
  //             className={isLoading.buttonClass}
  //             disabled={disableButton}
  //             loader={isLoading.loadingIcon}
  //           />
  //         </div>
  //       </form>
  //     </div>

  //     {/* <div className="signin__privacy">
  //     <ActionLink anchor={true} 
  //             href={PRIVACY_LINK.replace(/\{(.*?)\}/gi,t('signin.link.privacyDisclaimer',true))}
  //             value={t('signin.link.privacyDisclaimer')}
  //           />
  //     </div> */}
  //     <div className="signin__footer">
  //       {t('signin.footer')} <ActionLink value={t('signin.footer.link')} redirectTo="/signUp" />
  //     </div>
  //   </div>
  // );
};

export default SignInAccount;
